import axiosBasicInstance from '../axiosConfig';

const getListWorkHourSummaryReport = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/workHourSummaryReport', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const getUserDetailReport = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/userDetailReport', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const getTotalWorkHoursReport = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/totalWorkHoursReport', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const getProductivityReport = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/productivityReport', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const getEventDetailReport = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/eventDetailReport', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const getDeviceReport = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/deviceReport', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const getArrivalDepartureReport = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/arrivalDepartureReport', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const exportListWorkHourSummaryReportCSV = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/workHourSummaryReportCSV', data, {
         responseType: 'blob'  
      });
      return response;
   } catch (error) {
      throw error;
   }
};

const exportTotalWorkHoursReportCSV = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/totalWorkHoursReportCSV', data, {
         responseType: 'blob'  
      });
      return response;
   } catch (error) {
      throw error;
   }
};

const exportProductivityReportCSV = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/productivityReportCSV', data, {
         responseType: 'blob'  
      });
      return response;
   } catch (error) {
      throw error;
   }
};

const exportUserDetailsReportCSV = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/userDetailsReportCSV', data, {
         responseType: 'blob'  
      });
      return response;
   } catch (error) {
      throw error;
   }
};

const exportEventDetailsReportCSV = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/eventDetailsReportCSV', data, {
         responseType: 'blob'  
      });
      return response;
   } catch (error) {
      throw error;
   }
};

const exportDeviceReportCSV = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/deviceReportCSV', data, {
         responseType: 'blob'  
      });
      return response;
   } catch (error) {
      throw error;
   }
};

const exportArrivalAndDepartureReportCSV = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/arrivalAndDepartureReportCSV', data, {
         responseType: 'blob'  
      });
      return response;
   } catch (error) {
      throw error;
   }
};

const updateReport = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/update-report', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export { getListWorkHourSummaryReport, 
         getUserDetailReport, 
         getTotalWorkHoursReport, 
         getProductivityReport, 
         getEventDetailReport, 
         getDeviceReport, 
         getArrivalDepartureReport, 
         exportListWorkHourSummaryReportCSV, 
         exportTotalWorkHoursReportCSV, 
         exportProductivityReportCSV,
         exportUserDetailsReportCSV,
         exportEventDetailsReportCSV,
         exportDeviceReportCSV,
         exportArrivalAndDepartureReportCSV,
         updateReport};
